var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"page",staticClass:"page",class:{
        'page--turned': _vm.turned,
        'page--front': _vm.front,
        'page--back': _vm.back,
        'page--hidden': _vm.hidden
    }},_vm._l((_vm.sides),function(side){return _c('div',{class:`page__${ side }`,on:{"click":function($event){return _vm.onSideClicked(side)}}},[(_vm.sideIsPixi(side))?_c('canvas',{ref:side === 'front' ? 'canvasFront' : 'canvasBack',refInFor:true}):_vm._l((_vm.page.layers.filter(currentLayer => currentLayer.side === side)),function(layer){return _c('app-layer',{key:layer.id,attrs:{"layer":layer,"templateOverrides":_vm.templateOverrides,"pageWidth":_vm.pageWidth,"pageHeight":_vm.pageHeight}})})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }